import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';
import {
  Row,
  Col,
} from 'react-bootstrap';

import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';


const propTypes = exact({
  ticket: PropTypes.object.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  ticketId: PropTypes.number.isRequired,
  hasHourlyBilling: PropTypes.bool.isRequired,
});


const TicketCalculatedFields = (props) => {
  const { ticket, hasHourlyBilling } = props;
  const {
    revenue_per_billable_hour: revPerBillHour,
    revenue_per_worked_hour: revPerWorkedHour,
  } = ticket;

  const displayRevenuePerBillableHour = (revPerBillHour) ? `$${revPerBillHour}` : '-';
  const displayRevenuePerWorkedHour = (revPerWorkedHour) ? `$${revPerWorkedHour}` : '-';

  return (
    <React.Fragment>
      <Row>
        <Col md={12} style={{ textAlign: 'center' }}>
          <Row style={{ marginBottom: '15px' }}>
            {hasHourlyBilling && (
              <Col md={12}>
                <strong> {displayRevenuePerBillableHour} / Billable Hr</strong><br />
              </Col>
            )}
          </Row>
          <Row>
            <Col md={12}>
              <strong> {displayRevenuePerWorkedHour} / Man Hr</strong><br />
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};


TicketCalculatedFields.propTypes = propTypes;


export const GetTicketCalculatedFieldsQuery = gql`
  query GetTicketCalculatedFields($ticketId: Int!) {
    ticket(ticket_id: $ticketId) {
      id
      revenue_per_billable_hour
      revenue_per_worked_hour
      department {
        id
        has_hourly_billing
      }
    }
  }
`;

const withData = graphql(GetTicketCalculatedFieldsQuery, {
  options: { fetchPolicy: 'network-only' },
});

const mapDataToProps = withProps((props) => {
  const { data } = props;
  const { ticket } = data;
  const { has_hourly_billing: hasHourlyBilling } = ticket.department;

  return {
    ticket,
    hasHourlyBilling,
  };
});

const enhance = compose(
  withData,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data']),
);

export default enhance(TicketCalculatedFields);
